import React from "react";
import "../Navigation/css/NavBar.scss";
import {Black} from "../../theme/styles";


export default function AttachmentsPut() {

    return (
        <div style={{paddingLeft: "20px", paddingRight: "30px"}}>
            <p style={{fontSize: "24px", fontWeight: "400", color: Black}}>Attachments PUT</p>
            <p style={{fontSize: "16px", fontWeight: "400", color: Black}}>Attachments PUT REST API</p>

        </div>
    )
}